Object.defineProperty(exports, '__esModule', {
  value: true
});
var removeTimezoneOffset = function removeTimezoneOffset(date) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
};
exports.removeTimezoneOffset = removeTimezoneOffset;